/*
*   File : explore.js
*   Author : https://evoqins.com
*   Description : Explore page of indvestment
*   Integrations : NA
*   Version : 1.0.0
*/

import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Modal } from 'bootstrap';

//Style
import style from "../../Styles/Component/explore.module.scss";

//Custom components
import { CustomTab, Loader, OverLay } from '../../Component/Others';
import { AlphaBasketCard, CategoryTab, CreatorCard } from '../../Component/Cards';
import { Icon } from '../../Component/Icon';
import { ConnectBrokerModal } from '../../Component/Modal';
import { APIService } from '../../Service';
import { useSelector } from 'react-redux';
import { _scrollToTop } from '../../Helper';

const TAB_DATA = [
    {
        id: 1,
        label: "Products",
    },
    {
        id: 2,
        label: "Creators"
    },
];

const TOP_PRODUCT_TAB = [
    {
        id: 1,
        label: "alphaBasket",
    },
    {
        id: 2,
        label: "alphaBasket pro",
    },
    // {
    //     id: 3,
    //     label: "alphaStocks",
    // },
    // {
    //     id: 4,
    //     label: "alphaOptions",
    // },
    // {
    //     id: 5,
    //     label: "alphaMF",
    // },
];


const Explore = () => {

    const USER_DATA = useSelector((store) => store.Reducer.USER_DATA);
    const scrollRef = useRef(null);
    const navigate = useNavigate();
    const { state } = useLocation();
    const [productList, setProductList] = useState([]);
    const [creatorsList, setCreatorsList] = useState([]);
    const [tabIndex, setTabIndex] = useState(state && state.tab_index ? state.tab_index : 1);
    const [categoryTab, setCategoryTab] = useState(state ? state.category_tab : 1);
    // const [searchValue, setSearchValue] = useState("");
    // const [selectedSort, setSelectedSort] = useState(null);
    const [toggleSort, setToggleSort] = useState(false);
    const [toggleFilter, setToggleFilter] = useState(false);
    // const [selectedRiskIds, setSelectedRskIds] = useState([]);
    // const [selectedObjectiveIds, setSelectedObjectiveIds] = useState([]);
    const [connectModal, setConnectModal] = useState(false);
    const [dataLoading, setDataLoading] = useState(true);
    const [creatorsDataLoading, setCreatorsDataLoading] = useState(true);

    useEffect(() => {
        if (state && state.tab_index === 2 && creatorsList.length === 0) {
            _getCreatorsList();
        };
    }, []);

    useEffect(() => {
        // Scroll the page to top
        _scrollToTop();
    }, [tabIndex]);

    useEffect(() => {
        // API Calls
        setDataLoading(true);
        _getProductList();
    }, [categoryTab]);

    // useEffect(() => {
    //     if (state !== null) {
    //         setTabIndex(state.tab_index);
    //     } else {
    //         setTabIndex(1);
    //     }
    // }, [state]);

    // useEffect(() => {
    //     if (state !== null) {
    //         setCategoryTab(state.category_tab);
    //     } else {
    //         setCategoryTab(1);
    //     }
    // }, [state]);

    useEffect(() => {
        if (toggleFilter === true || toggleSort === true) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
    }, [toggleFilter, toggleSort]);

    useEffect(() => {
        if (connectModal === true) {
            const connect_modal = new Modal(document.getElementById('connect-modal'));
            connect_modal.show();
        }
    }, [connectModal]);

    // handle tab change
    const _handleExploreTab = (id) => {

        if (creatorsList.length == 0 && id === 2) {
            _getCreatorsList();
        };

        navigate("/explore", {
            state: {
                tab_index: id,
                category_tab: 1
            }
        });

        setTabIndex(id);
    };

    // handle category tab change
    const _handleCategoryTab = (selected) => {
        setCategoryTab(selected);
        navigate("/explore", {
            state: {
                tab_index: 1,
                category_tab: selected
            }
        });
    };

    // handle search 
    // const _handleSearch = (value) => {
    //     setSearchValue(value);
    // };

    // handle navigate to brokers list 
    const _handleNavigateBrokers = () => {
        navigate("/account/brokers");
    };

    // handle sort toggle modal 
    // const _handleSortToggle = () => {
    //     setToggleSort(!toggleSort)
    //     if (scrollRef.current) {
    //         scrollRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    //     }
    // };

    //handle select sort
    // const _handleSelectSort = (id) => {
    //     setSelectedSort(id);
    // };

    // handle clear selected sort option 
    // const _handleClearSort = () => {
    //     setSelectedSort(null);
    // };

    // handle cancel sort 
    // const _handleCancelSort = () => {
    //     setToggleSort(false);
    //     setSelectedSort(null);
    // };

    // handle apply sort 
    // const _handleApplySort = () => {
    //     setToggleSort(false);
    // };

    // handle toggle filter 
    // const _handleToggleFilter = () => {
    //     setToggleFilter(!toggleFilter);
    //     if (scrollRef.current) {
    //         scrollRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    //     }
    // };

    // handle select risk filter
    // const _handleFilterRisk = (id) => {
    //     if (selectedRiskIds.includes(id)) {
    //         setSelectedRskIds(selectedRiskIds.filter(risk_id => risk_id !== id));
    //     } else {
    //         setSelectedRskIds([...selectedRiskIds, id]);
    //     }
    // };

    // handle select objective filter 
    // const _handleFilterObjective = (id) => {
    //     if (selectedObjectiveIds.includes(id)) {
    //         setSelectedObjectiveIds(selectedObjectiveIds.filter(objective_id => objective_id !== id));
    //     } else {
    //         setSelectedObjectiveIds([...selectedObjectiveIds, id]);
    //     }
    // };

    // handle clear filter 
    // const _handleClearFilter = () => {
    //     setSelectedRskIds([]);
    //     setSelectedObjectiveIds([]);
    // };

    // handle apply filter 
    // const _handleApplyFilter = () => {
    //     setToggleFilter(false);
    // };

    // handle cancel filter 
    // const _handleCancelFilter = () => {
    //     setToggleFilter(false);
    //     setSelectedRskIds([]);
    //     setSelectedObjectiveIds([]);
    // };

    // handle navigate create basket 
    // const _handleCreateBasket = () => {
    //     navigate("/basket");
    // };

    // handle navigate basket detail 
    const _handleBasketDetail = (strategy_id, creator_id) => {

        // if (USER_DATA.user_brokers_info.length === 0) {
        if (false) {
            setConnectModal(true);
        } else {
            navigate("strategy-detail", {
                state: {
                    "strategy_id": Number(strategy_id),
                    "strategy_type": categoryTab == 1 ? "alphaBasket" : "alphaBasket pro",
                    "category_tab": categoryTab,
                    "tenant_id": Number(creator_id)
                }
            });
        }
    };

    // handle navigate to creator detail 
    const _handleCreatorDetail = (creator_id) => {
        navigate("creator-detail", {
            state: {
                creator_id: Number(creator_id)
            }
        });
    };

    // handle navigate to details page
    const _handleConnectBroker = () => {
        navigate("/kyc-verification");
    };


    // ========== API CAllS ========== //
    // Get product list data
    const _getProductList = async () => {

        let url = "products/baskets/list";
        let data = {
            "strategy_type": categoryTab == 1 ? "alpha-basket" : "alpha-basket-pro",
            "tenant_id": USER_DATA.referral_master_info.creator_id,
            "user_id": USER_DATA.unique_identifier,
        };

        const response = await APIService(url, data);

        if (response.status_code === 200) {
            setProductList(response.data);
        } else {
            // setProductList("");
        }
        setDataLoading(false);
    };

    // Get Creators list data
    const _getCreatorsList = async () => {

        let url = "products/list-creators";
        let data = {
            "user_id": USER_DATA.unique_identifier,
        };

        const response = await APIService(url, data);

        if (response.status_code === 200) {
            setCreatorsList(response.data);
        } else {
        }
        setCreatorsDataLoading(false);
    };


    return (

        <section className='position-relative min-vh-100'>
            <div className={`${style.e_top_section} border-radius-16 px-4 padding-32px-top e-padding-16px-top-res overflow-hidden`}>
                <h4 className='e-font-16-res mb-0 e-primary-font-clash-display e-text-white e-font-20 e-font-weight-500 line-height-24px'>
                    Explore
                </h4>
                {/* Custom tab */}
                <div className='d-flex gap-24px-res gap-40px padding-36px-top e-padding-16px-top-res'>
                    {TAB_DATA.map((tab, key) => (
                        <div key={key}>
                            <CustomTab tabIndex={tabIndex}
                                data={tab}
                                handleClick={_handleExploreTab} />
                        </div>
                    ))}
                </div>
            </div>
            <div ref={scrollRef}>
                {/* Category tab section */}
                {tabIndex === 1 &&
                    <div className='e-bg-magnolia-extra-light px-sm-3 padding-20px-tb'>
                        <div className='d-flex gap-3'>
                            <CategoryTab data={TOP_PRODUCT_TAB}
                                activeTab={categoryTab}
                                handleTabChange={_handleCategoryTab} />
                        </div>
                    </div>
                }
            </div>

            {
                dataLoading ?
                    <Loader wrapperClassName="min-vh-100 margin-100px-top" />
                    :
                    <>

                        {
                            tabIndex === 1 ?
                                <>
                                    {/* AlphaBasket card */}
                                    <div className='row row-gap-4 mb-5'>
                                        {productList.map((product, key) => (
                                            <div key={key} className='col-md-6'>
                                                <AlphaBasketCard product={product}
                                                    type={1}
                                                    // category={categoryTab == 1 ? "alphaBasket" : "alphaBasketPro"}
                                                    category={categoryTab}
                                                    handleClick={() => _handleBasketDetail(product.strategy_id, product.creator_info.creator_id)} />
                                            </div>
                                        ))}
                                    </div>

                                    {/* Put your money to work banner */}
                                    {
                                        USER_DATA && USER_DATA.user_brokers_info.length == 0 &&
                                        <div className='py-4 mt-2'>
                                            <div className={`${style.e_money_to_work_banner} border-radius-16 px-3 px-sm-4 cursor-pointer`}
                                                onClick={_handleNavigateBrokers} >
                                                <div className='row'>
                                                    <div className='col-8 my-auto'>
                                                        <h4 className='e-font-16-res mb-3 e-primary-font-clash-display e-text-white e-font-24 e-font-weight-500 line-height-24px'>
                                                            Put your money to work
                                                        </h4>
                                                        <div className='d-flex gap-2px align-items-center'>
                                                            <span className='e-alt-font-lato e-text-white e-font-14 e-font-weight-600 line-height-16px'>
                                                                Connect with stock brokers
                                                            </span>
                                                            <Icon icon="right-arrow"
                                                                color="#FFFFFF"
                                                                className="d-flex transition"
                                                                size="18px" />
                                                        </div>
                                                    </div>
                                                    <div className='col-4 text-center'>
                                                        <img src={require("../../Assets/Images/Dashboard/money-to-work-img.png")}
                                                            draggable={false}
                                                            className='img-fluid width-184px h-128 object-fit-contain'
                                                            alt='banner-img' />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }

                                    {/* AlphaBasket card */}
                                    {/* <div className='row row-gap-4 pb-4'>
                                        {TOP_PRODUCTS.map((products, key) => (
                                            <div key={key} className='col-md-6'>
                                                <AlphaBasketCard product={products}
                                                    type={1}
                                                    category={categoryTab}
                                                    handleClick={_handleBasketDetail} />
                                            </div>
                                        ))}
                                    </div> */}

                                    {/* Create own basket btn */}
                                    {/* <div className='position-sticky text-end pe-3 pb-4 bottom-24px'>
                                        <PrimaryButton name="Create Own Baskets"
                                            icon={true}
                                            className="padding-18px-tb border-radius-48"
                                            padding="padding-12px-lr"
                                            onPress={_handleCreateBasket} />
                                    </div> */}
                                </>
                                :
                                <>
                                    {
                                        creatorsDataLoading ?
                                            <Loader wrapperClassName="min-vh-100 margin-100px-top" />
                                            :
                                            <div className='row row-gap-4 pb-4 mt-4'>
                                                {creatorsList.map((creators, key) => (
                                                    <div key={key} className='col-sm-6'>
                                                        <CreatorCard creator={creators}
                                                            handleClick={_handleCreatorDetail} />
                                                    </div>
                                                ))}
                                            </div>
                                    }
                                </>
                        }



                    </>
            }

            {/* Connect broker modal */}
            {
                connectModal === true &&
                <ConnectBrokerModal
                    handleClose={() => setConnectModal(false)}
                    handleSuccess={_handleConnectBroker} />
            }
        </section>
    )
}

export default Explore;

//  Hide sort filter and search
// <div className='row py-4 row-gap-3 flex-sm-nowrap gx-3'>
{/* <div className='order-2 order-sm-1 col-6 col-sm-auto pe-sm-0'>
                        <div className='position-relative'>
                            <div className='e-padding-8px-tb-12px-lr-res d-flex gap-6px justify-content-between align-items-center e-border-0-5-ocean-blue e-bg-magnolia px-sm-3 padding-10px-tb border-radius-100 cursor-pointer'
                                onClick={_handleSortToggle}>
                                <p className='e-font-12-res mb-0 e-text-chinese-black e-alt-font-lato e-font-14 e-font-weight-600 line-height-20px'>
                                    Sort by
                                </p>
                                <Icon icon="drop-down-icon"
                                    color="#141514"
                                    className="d-flex"
                                    size="12px" />
                            </div>

                            {
                                toggleSort &&
                                <>
                                    <OverLay isOpen={toggleSort} onClose={_handleCancelSort} />
                                    <BasketSortModal options={SORT_OPTIONS}
                                        selected={selectedSort}
                                        handleSelect={_handleSelectSort}
                                        handleClear={_handleClearSort}
                                        handleCancel={_handleCancelSort}
                                        handleApply={_handleApplySort} />
                                </>
                            }
                        </div>
                    </div>
                    <div className='ms-auto order-1 order-sm-2 col-12 col-sm-6 col-md-5'>
                        <div className='d-flex align-items-center gap-2 justify-content-end'>
                            <CustomSearchInput placeholder="Search with product names"
                                type="text"
                                wrapperClassName="d-flex justify-content-center overflow-hidden w-100"
                                require
                                search={true}
                                value={searchValue}
                                handleChange={(e) => _handleSearch(e)} />

                        </div>
                    </div>
                    <div className="order-3 col-6 col-sm-auto ps-sm-0">
                        <div className='position-relative col-auto'>
                            <div className='e-padding-8px-tb-12px-lr-res d-flex gap-6px align-items-center e-border-0-5-ocean-blue e-bg-magnolia px-sm-3 padding-10px-tb border-radius-100 cursor-pointer'
                                onClick={_handleToggleFilter}>
                                <div className='d-flex position-relative'>
                                    <img src={require("../../Assets/Images/Other/filter.svg").default}
                                        width={18} />
                                    <span class="position-absolute top-0 left-84-per translate-middle badge rounded-pill e-bg-filter-count e-text-white e-alt-font-lato e-font-8 e-font-weight-700 line-height-10px px-1 padding-1px-top padding-2px-bottom">
                                        2
                                    </span>
                                </div>
                                <p className='e-font-12-res mb-0 e-text-chinese-black e-alt-font-lato e-font-14 e-font-weight-600 line-height-20px'>
                                    Filter
                                </p>
                            </div>

                            {toggleFilter &&
                                <>
                                    <OverLay isOpen={toggleFilter} onClose={_handleCancelFilter} />
                                    <BasketFilterModal riskOptions={RISK_OPTIONS}
                                        objectiveOptions={OBJECTIVE_OPTIONS}
                                        selectedRisks={selectedRiskIds}
                                        selectedObjectives={selectedObjectiveIds}
                                        handleSelectRisk={_handleFilterRisk}
                                        handleSelectObjective={_handleFilterObjective}
                                        handleClear={_handleClearFilter}
                                        handleCancel={_handleCancelFilter}
                                        handleApply={_handleApplyFilter} />
                                </>
                            }
                        </div>
                    </div> */}
// </div>
